import { AxiosRequestConfig } from 'axios';

import api from 'services/api';
import type { BankSlipRow } from 'pages/BankSlip/utils/bankSlipDisplay';

import { getAccessToken } from './accessTokenServices';

export type OverdueBankSlipsResult =
  | { ok: true; rows: BankSlipRow[] }
  | { ok: false };

type InvoiceResponse = BankSlipRow['invoice'] & {
  installments?: BankSlipRow['installment'][];
};

export const getOverdueBankSlips =
  async (): Promise<OverdueBankSlipsResult> => {
    const access_token = await getAccessToken();

    const customerCode = localStorage.getItem(
      '@UltragazEmpresarial:customerCode'
    );
    const customerSiteCode = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );

    const parameters = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        access_token,
      },
      params: {
        'customer-site-code': customerSiteCode,
        'customer-code': customerCode,
        'typeable-line': 'NOT_NULL',
        _expand: 'installments',
        status: 'VENCIDO',
        _limit: 100,
        _offset: 0,
      },
    } as AxiosRequestConfig;

    try {
      const response = await api.get<InvoiceResponse[]>(
        'industrial/invoice/v1/invoices',
        parameters
      );

      const rows: BankSlipRow[] = [];

      (response.data ?? []).forEach((invoice) => {
        (invoice.installments ?? []).forEach((installment) => {
          if (!installment.typeableLine) return;
          rows.push({ invoice, installment });
        });
      });

      return { ok: true, rows };
    } catch (error) {
      return { ok: false };
    }
  };

export default getOverdueBankSlips;
